import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Route, Switch, useHistory } from 'react-router-dom'
import { Add } from '@mui/icons-material'
import { useStores } from '@trivie/core'
import { TableHelper } from '../../../tables'
import { Header } from '@trivie/ui-web/components/header'
import { CardTable } from '../../../tables/card-table'

export const CardsScreen: React.FunctionComponent = observer(() => {
  const { contentCreationStore, cardStore, manageUserStore } = useStores()
  const { reset } = cardStore
  const { resetContentStore } = contentCreationStore
  const { permissions } = manageUserStore

  const [tableHelper] = useState(new TableHelper('list_cards', 'cards', 'cards'))

  const history = useHistory()

  const primary = {
    disabled: !permissions?.permissions.some((p) => p.code === 'can_create_question'),
    startIcon: <Add />,
    onClick: () => {
      resetContentStore()
      reset()
      history.push('/content/card/create')
    },
    text: 'Create Info Card',
  }

  return (
    <Switch>
      <Route exact path="/content/cards">
        <Header divider title="Info Cards" primaryAction={primary} />
        <CardTable tableHelper={tableHelper} />
      </Route>
      {/* <Route path="/content/cards/:id/:tab">
        <CardDetailsScreen />
      </Route> */}
    </Switch>
  )
})
